import { app } from '../../../../../../app';
import { Controller } from './assign-group-to-application.controller';

app.component('companyUserDirectoriesManageGroupApplicationsAssign', {
    bindings: {
        applications: '<',
        companyId: '<',
        group: '<',
    },
    controller: Controller,
    templateUrl: require('./assign-group-to-application.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/manage-group/applications/assign/assign-group-to-application.component.js